module.exports = __webpack_public_path__ + "static/media/mobil-vector-logo.4bf98b28.svg";